<template>
    <common-content-wrapper width="small">
        <form-wrapper v-if="isRegistration">
            <form-row>
                <form-cell>
                    <date-range-field
                        :formData="data"
                        openSide="right"
                        :isSingle="true"
                        :allowedDays="[1, 2, 3, 4, 5]"
                        dateFormat="dddd, mmmm d yyyy"
                        valuePath="dateRange"
                        :minDate="new Date()"
                        @change="dateChange($event)"
                    ></date-range-field>
                </form-cell>
            </form-row>
        </form-wrapper>
        <common-highlight v-else :content="formattedStartDate"></common-highlight>
    </common-content-wrapper>
</template>

<script>
    import dayjs from 'dayjs'
    import get from 'lodash/get'
    import FormMixin from 'mixins/FormMixin'

    export function generateStartDate(frequency) {
        // Monday is the first day of the work week
        const dayOfWeek = dayjs().day() || 7 //convert 0 to 7
        const startOfNextWorkWeek = dayjs().add(8 - dayOfWeek, 'day')

        return frequency === 'weekly' || startOfNextWorkWeek.week() % 2 === 1
            ? startOfNextWorkWeek
            : startOfNextWorkWeek.add(1, 'weeks')
    }

    export default {
        mixins: [FormMixin],
        props: {
            frequency: { type: String, required: true },
            isRegistration: { type: Boolean, default: false },
            date: { type: Date, default: undefined },
        },

        computed: {
            startDate() {
                return generateStartDate(this.frequency)
            },

            formattedStartDate() {
                return this.date ? dayjs(this.date).format('dddd, MMMM D YYYY') : this.startDate.format('dddd, MMMM D YYYY')
            },
        },

        methods: {
            dateChange(event) {
                this.$emit('startWeekDateSelected', get(event, 'value.startDate', this.startDate.toDate()))
            },
        },

        created() {
            if (this.isRegistration) {
                this.data.dateRange = {
                    startDate: this.startDate.toDate(),
                    endDate: this.startDate.toDate(),
                }
            }
        },
    }
</script>
